import React from "react";
import ReactDOM from "react-dom";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import "./index.css";
import "bootswatch/dist/lux/bootstrap.min.css";
//import 'bootstrap/dist/css/bootstrap.min.css';
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.min.js";

// Components:
import Navbar2 from "./components/navbar/Navbar";
import HomePage from "./pages/turnos/Turnos";
import Login from "./pages/login/Login";
import ClientesSection from "./pages/clientes/Clientes";
import ProductosSection from "./pages/productos/Productos";
import ServiciosSection from "./pages/servicios/Servicios";
import PrivateRoute from "./utils/PrivateRoute";
import { AuthProvider } from "./context/AuthContext";
import CreateVisitaForm from "./pages/visitas/CreateVisitaForm";
import VisitaTable from "./pages/visitas/VisitaTable";

ReactDOM.render(
  <Router>
    <AuthProvider>
      <Navbar2 />
      <div className="container-fluid">
        <Routes>

          <Route exact path="/" element={<PrivateRoute />}>
            <Route exact path="/" element={<HomePage />} />
          </Route>

          <Route exact path="/visitas" element={<PrivateRoute />}>
            <Route exact path="/visitas" element={<VisitaTable />} />
          </Route>

          <Route exact path="/nuevavisita" element={<PrivateRoute />}>
            <Route exact path="/nuevavisita" element={<CreateVisitaForm />} />
          </Route>

          <Route exact path="/clientes" element={<PrivateRoute />}>
            <Route exact path="/clientes" element={<ClientesSection />} />
          </Route>

          <Route exact path="/productos" element={<PrivateRoute />}>
            <Route exact path="/productos" element={<ProductosSection />} />
          </Route>

          <Route exact path="/servicios" element={<PrivateRoute />}>
            <Route exact path="/servicios" element={<ServiciosSection />} />
          </Route>

          <Route path="/login" element={<Login />} />
          
        </Routes>
      </div>
    </AuthProvider>
  </Router>,

  document.getElementById("root")
);
